import { AxiosError, AxiosInstance } from 'axios';

import { sentryLogger } from './sentryLogger';

/** Adds Sentry interceptor, sentryLogger decides if error is meaningful and if it is, it will be sent to Sentry */
export function includeSentryInterceptor(axios: AxiosInstance) {
  axios.interceptors.response.use(
    (resp) => resp,
    (err: AxiosError) => {
      sentryLogger.logFailedRequest(err);
      return Promise.reject(err);
    }
  );
}
